import { useLocalSearchParams } from "expo-router";
import { useMemo } from "react";
import { StyleSheet } from "react-native";
import { useAppSelector } from "../../../src/hooks";

import { useV2GetBundleBySlugQuery } from "@stepapp/core";
import { Block, CollapsibleChecklist, Divider, Loader, palette, spacing } from "@stepapp/ui";
import { useTranslation } from "react-i18next";
import { ScrollView } from "react-native";
import { ServiceSceneDescription, ServiceSceneHeader } from "../../../src/components";

const ServiceChecklistScreen = () => {
  const { t } = useTranslation();
  const { slug } = useLocalSearchParams<{ slug: string }>();
  const initialSlug = useMemo(() => slug as string, [slug]);
  const localizationId = useAppSelector(({ appConfig }) => appConfig.localizationId);

  const { data, loading } = useV2GetBundleBySlugQuery({
    variables: { localizationId, slug: initialSlug },
    fetchPolicy: "cache-and-network",
    skip: !slug,
  });

  const showLoader = loading && !data?.v2GetBundleBySlug?.id;
  const serviceChecklist = useMemo(() => data?.v2GetBundleBySlug?.checkList, [data]);

  return (
    <ScrollView contentContainerStyle={styles.container}>
      <ServiceSceneHeader name={t("screens.service.serviceRange")} />

      <ServiceSceneDescription
        loading={showLoader}
        description={data?.v2GetBundleBySlug?.name || ""}
      />

      <Block paddingVertical={1}>
        <Divider />
      </Block>

      {showLoader && (
        <Block alignCenter justifyCenter>
          <Loader />
        </Block>
      )}

      {!!serviceChecklist && serviceChecklist?.length > 0 && (
        <CollapsibleChecklist checklist={serviceChecklist} />
      )}
    </ScrollView>
  );
};

export default ServiceChecklistScreen;

const styles = StyleSheet.create({
  container: {
    backgroundColor: palette.common.white,
    borderTopLeftRadius: spacing.radius * 2,
    borderTopRightRadius: spacing.radius * 2,
    minHeight: spacing.deviceHeight,
  },
});
